import * as Yup from 'yup';
import { SERVICE_TYPE_GOVERNMENT, SERVICE_TYPE_PAYED } from '../../redux/constants/serviceTypeConstants';

export const serviceSchema = Yup.object().shape({
    name: Yup.string('Это не строка').required('Полное наименование услуги'),
    code: Yup.string('Это не строка'),
    price: Yup.number('Это не число').min(0, 'Цена не может быть отрицательной'),
    departmentId: Yup.number('Это не число'),
    divisionId: Yup.number('Это не число'),
    serviceType: Yup.number('Это не число').oneOf([SERVICE_TYPE_GOVERNMENT, SERVICE_TYPE_PAYED], 'Тип должен быть Гос. заказ или Платные'),
    createRequestWithoutAct: Yup.boolean('Это не булево значение'),
});
